import React, {useState} from 'react';
import Checkin from './HistoriqueComponent/Checkin';
import Note from './HistoriqueComponent/Note';
import TodoList from './HistoriqueComponent/TodoList';
import Photo from './HistoriqueComponent/Photo';
import PDF from './HistoriqueComponent/PDF';
import moment from 'moment-timezone';


/**
 *  La vue de l'historique
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoHistoriqueView(props) {

  const [checkedGraph, setCheckedGraph] = useState(false);

  const formatDate = (dateString) => {
    const date = moment.tz(dateString, 'America/Montreal');
    const dayNames = {
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Sunday: 'Dimanche',
    };
    moment.locale('fr'); // set locale to French
    const dayName = dayNames[date.format('dddd')];
    return `${dayName} le ${date.format('DD-MM-YYYY')}`;
  };

  const handleCheckedGraph = () => {
    setCheckedGraph(!checkedGraph);
  };

  return (
    <React.Fragment>

<React.Fragment>
        <label className="checkin-toggle-switch-label">Voir graphique ?</label>
        <div className="toggle-switch checkin-toggle-switch" >
          <div>
            <input
              id="toggle"
              type="checkbox"
              checked={checkedGraph}
              onChange={handleCheckedGraph} />
            <label htmlFor="toggle"></label>
          </div>
          <div>
          </div>
        </div>
      </React.Fragment>

      {props.historique.map((item, index) => {
         if (item.type === 'checkin')
         return <Checkin key={index} checkin={item} formatDate={formatDate} checkedGraph={checkedGraph}/>;
        else if (item.type === 'note')
         return <Note key={index} note={item} formatDate={formatDate} />;
        else if (item.type === 'todolist')
         return <TodoList key={index} todolist={item} formatDate={formatDate} />;
        else if (item.type === 'photo' || item.type === 'facture')
         return <Photo key={index} photo={item} formatDate={formatDate} />;
        else
         return <PDF key={index} file={item} formatDate={formatDate} />;
      })}
    </React.Fragment>
  );
}

export default ChantierInfoHistoriqueView;
